<template>
  <div class="section section-settings" id="judgeSaidao">
    <div class="layout-content">
      <SubTitle :text="title" :subText="subText" />

      <div class="content-bg">
        <div class="content-race">

          <div
            class="content-list"
            :style="{ '--background-color': activityIndex === item.id ? item.fontActiveBgColor : '' }"
            v-for="item in data"
            :key="item.id"
            @click="setActivity(item)"
          >

            <img
              ref="img"
              class="content-race-img"
              :src="activityIndex === item.id ? item.logo : isMobile ? item .logoGrey : item.logoBlack"
              alt=""
            />

            <p
              class="content-race-title"
              :style="{ '--font-color': activityIndex === item.id ? item.fontActiveColor : isMobile ? '#7A7C7D' : '#000000' }"
            >
              {{isMobile ? item.mobileTitle : item.title}}
            </p>
          </div>
        </div>

        <div v-for="item in data" :key="item.id">
          <div class="judges-bg-wrapper" v-show="activityIndex === item.id">
            <div
              class="judges-bg"
              :style="{ '--title-bg': activityIndex === item.id ? isMobile ? item.mobileTitleBgColor : item.titleBgColor : ''}"
            >
              <img class="judges-img" :src="isMobile ? item.mainJudge.mobileImg : item.mainJudge.img" alt="">
              <div class="judges-wrapper">
                <p class="judges-name">{{item.mainJudge.name}}</p>
                <p class="judges-title">{{item.mainJudge.conTitle}}</p>
              </div>
              <span class="judges-identity">{{item.mainJudge.position}}</span>
            </div>

            <div class="competition-review">
              <div class="competition-line" />
              <span class="competition-review-title">{{isMobile ? item.Judgers.mobileTitle : item.Judgers.title}}</span>
              <div class="competition-line" />
            </div>

            <div class="competition-wrapper">
              <div class="competition-judges">
                <div
                  class="competition-judges-wrapper"
                  v-for="(item, index) in item.Judgers.data"
                  :key="index"
                >
                  <p class="competition-judges-name">{{item.name}}</p>
                  <p class="competition-judges-title" v-html="item.position" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import SubTitle from '@/components/SubTitle'
import { mapState } from 'vuex'

export default {
  props: ['data'],
  components: {
    SubTitle
  },
  data () {
    return {
      activityIndex: 0
    }
  },
  computed: {
    ...mapState([
      'isMobile',
      'isEnLang'
    ]),
    title () {
      return this.isEnLang ? 'JUDGES' : '赛道评委'
    },
    subText () {
      return this.isEnLang ? 'FINTECHATHON' : 'JUDGES'
    }
  },
  mounted () {
  },
  methods: {
    setActivity (item) {
      this.activityIndex = item.id
    },
  }
}
</script>

<style lang="scss" scoped>

.section-settings {
  background: $bgGrey;
  padding-bottom: 120px;

  @include mobile {
    padding-bottom: 50px;
  }
}

.content-bg {
  display: flex;
  width: 100%; height: 978px;
  padding: 70px 66px 65px 48px;
  background: #FFFFFF;

  @include mobile {
    flex-direction: column;
    background: none;
    height: 100%;
    padding: 6px 0 0;
  }
}

.content-race {
  display: flex; justify-content: center;
  flex-direction: column;
  margin: 0 73px 0 0;

  @include mobile {
    // column-gap: 32px;
    height: 40px;
    justify-content: space-between;
    margin: 0;
    flex-direction: row;
  }
}

.content-list {
  display: flex; flex-direction: column; justify-content: center; align-items: center;
  width: 200px; height: 200px;
  margin-bottom: 62px;
  cursor: pointer;
  background: var(--background-color);

  &:last-child {
    margin-bottom: 0;
  }

  @include mobile {
    align-items: flex-start; flex-direction: row;
    width: auto; height: auto;
    margin-bottom: 20px;
    background: none;
  }
}

.content-race-img {
  width: 40px; height: 40px;
  margin-bottom: 18px;

  @include mobile {
    width: 22px; height: 22px;
    margin-right: 6px;
  }
}

.content-race-title {
  font-size: 20px; font-family: Alibaba-PuHuiTi-Heavy;
  line-height: 27px;
  color: var(--font-color);

  @include mobile {
    font-size: 15px;
    font-family: PingFangSC-Semibold, PingFang SC;
    line-height: 21px;
    // opacity: 0.5;
  }
}

.judges-bg-wrapper {
  @include mobile {
    width: 100%; height: 100%;
    padding: 10px;
    background: #FFFFFF;
  }
}

.judges-bg {
  position: relative;
  display: flex; align-items: center;
  box-sizing: border-box;
  width: 777px; height: 81px;
  margin-left: 46px;
  padding: 17px 35px 13px 56px;
  margin-bottom: 38px;
  background: var(--title-bg);

  @include mobile {
    flex-direction: column; align-items: flex-start; justify-content: space-between;
    width: 100%; height: 140px;
    margin: 0 0 25px 0;
    padding: 22px 24px 15px;
  }
}

.judges-img {
  position: absolute; left: -50px; top: -19px;
  width: 100px; height: 100px;

  @include mobile {
    left: 24px; top: 22px;
    width: 56px; height: 56px;
  }
}

.judges-wrapper {
  margin-left: 10px;

  @include mobile {
    margin: 6px 0 0 73px;
  }
}

.judges-name {
  margin-bottom: 6px;
  font-size: 20px; font-family: Alibaba-PuHuiTi-Heavy;
  color: #000000;
  line-height: 30px;

  @include mobile {
    font-size: 16px;
    line-height: 22px;
  }
}

.judges-title {
  margin-right: 22px;
  font-size: 13px; font-weight: 600;
  color: #000000;
  line-height: 19px;

  @include mobile {
    font-size: 11px; font-weight: 400;
    line-height: 16px;
  }
}

.judges-identity {
  font-size: 14px; font-weight: 400;
  color: #000000;
  line-height: 29px;

  @include mobile {
    font-size: 11px;
    line-height: 16px;
    opacity: 0.5;
  }
}

.competition-wrapper {
  overflow-x: auto;
}

::-webkit-scrollbar {
  width: 10px; height: 3px;
  background: #EDEEF0;
}

::-webkit-scrollbar-thumb {
  // width: 5px; height: 3px;
  width: 20px;
  background: #000000;
  // opacity: 0.9;
}

.competition-review {
  display: flex; align-items: center;
  margin-bottom: 37px;

  @include mobile {
    justify-content: center;
    margin-bottom: 21px;
    padding: 0 14px;
  }
}

.competition-line {
  width: 230px; height: 1px;
  background-color: #000000;
  transform: scaleY(0.5);

  @include mobile {
    width: 100%;
  }
}

.competition-review-title {
  padding: 0 50px;
  font-size: 16px; font-weight: 600;
  color: #000000;
  line-height: 22px;

  @include mobile {
    width: 182px;
    padding: 0 20px;
    font-size: 12px; font-weight: 600;
    color: #000000;
    line-height: 17px;
  }
}

.competition-judges {
  display: flex; flex-wrap: wrap;
  margin-left: 20px;

  @include mobile {
    display: flex; flex-wrap: wrap;
    width: 548px;
    margin-left: 14px;
    overflow-x: auto;
  }
}

.competition-judges-wrapper {
  width: 375px;
  margin-bottom: 20px;

  @include mobile {
    width: 274px;
    margin-bottom: 33px;
  }
}

.competition-judges-name {
  margin-bottom: 6px;
  font-size: 16px; font-weight: 600;
  color: #000000;
  line-height: 24px;

  @include mobile {
    font-size: 14px;
    font-family: PingFangSC-Semibold, PingFang SC;
    line-height: 20px;
  }
}

.competition-judges-title {
  font-size: 14px; font-weight: 400;
  color: #000000;
  line-height: 21px;
  opacity: 0.5;

  @include mobile {
    font-size: 12px;
    font-family: PingFangSC-Light, PingFang SC;
    line-height: 18px;
  }
}
</style>
